let white = '#ffffff'
let offWhite = '#F6F8FA'
let black = '#444'
let lightGrey = '#F1F1F1'
let grey = '#eee'

let green = '#BCFA46'
let blue = '#7657F7'
let red = '#e60000'
let orange = '#ff700b'
let purple = '#B744FB'
let yellow = '#FFFC49'

export { white, offWhite, black, lightGrey, grey, green, blue, red, orange, purple, yellow }
